module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ChTitle",
    attrs: {
      "id": "ch4"
    }
  }, [_c('a', {
    attrs: {
      "id": "ch4aa"
    }
  }), _c('a', {
    attrs: {
      "id": "ch4a"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rch4"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("THE TALENTED MISS AMERICA")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('i', [_vm._v("The Miss America Pageant added the talent portion to the contest in 1935. Most contestants sing or dance, but some display more unusual skills.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("1")]), _c('b', [_vm._v("957:")]), _vm._v(" Amanda Whitman (Miss Tennessee) did a gymnastic tumbling and trampoline routine to the theme from "), _c('i', [_vm._v("The Third Man")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("1959:")]), _vm._v(" Elizabeth Holmes (Miss New York) did an impression of French singer and actor Maurice Chevalier. Miss New Jersey, Beverly Ann Domareki, did an impression of a beatnik.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("1960:")]), _vm._v(" Ann Susan Barber (Miss New Jersey) did a comic routine about a hillbilly attending her first baseball game.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("1961:")]), _vm._v(" LaVerda Garrison (Miss Idaho) gave a dramatic reading of Charlotte Perkins Gilman’s feminist short story “The Yellow Wallpaper.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("1967:")]), _vm._v(" Jane Jayroe (Miss Oklahoma) conducted the orchestra in a rendition of the #2 hit “1-2-3” (and she won the pageant!).")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("1973:")]), _vm._v(" Ellen Meade (Miss Florida) did a ballet sequence from "), _c('i', [_vm._v("Swan Lake…on")]), _vm._v(" roller skates.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("1977:")]), _vm._v(" Julie Houston (Miss Alabama) played the banjo. The song: the theme from "), _c('i', [_vm._v("The Beverly Hillbillies")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("1981:")]), _vm._v(" Angelina Johnson (Miss Tennessee) did impressions of the lead characters from TV’s "), _c('i', [_vm._v("Laverne and Shirley")]), _vm._v("…with ventriloquist dummies.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("1982:")]), _vm._v(" Laura Matthys (Miss Oregon) twirled a rifle to the tune of a traditional folk march from Herzegovina.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("1987:")]), _vm._v(" Aurelie McCarthy (Miss Massachusetts) played “Hava Nagila” on the marimba.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("1989:")]), _vm._v(" Tammy Kettunen (Miss Arizona) performed a “freestyle roller-skating” routine to “Amazing Grace.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("1992:")]), _vm._v(" Shannon Boy (Miss Arkansas) played the theme from "), _c('i', [_vm._v("Star Wars")]), _vm._v(" on the flute.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_vm._v("2011:")]), _vm._v(" Lauren Cheape (Miss Hawaii) performed acrobatic jump roping to the "), _c('i', [_vm._v("Hawaii Five-O")]), _vm._v(" theme.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center7"
  }, [_c('span', [_c('b', [_vm._v("The expression “in a pickle” was coined by Shakespeare.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5e64404","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter004.vue
// module id = 90
// module chunks = 0